<template>
  <div class="show">
    <div class="eyes"></div>
    <div class="mouth"></div>
  </div>
</template>

<script>
export default {
  name: "show",
};
</script>

<style lang="scss">
  @keyframes blink {
   0%, 16.66% {
    background-image: url("~@/assets/img/eyes-open.png");
  }
  16.66%, 33.32% {
    background-image: url("~@/assets/img/eyes-closed.png");
  }
  33.32%, 49.98% {
    background-image: url("~@/assets/img/eyes-open.png");
  }
  49.98%, 66.64% {
    background-image: url("~@/assets/img/eyes-closed.png");
  }
  66.64%, 100% {
    background-image: url("~@/assets/img/eyes-open.png");
  }
   
}

@keyframes talk {
   0%, 12.66% {
    background-image: url("~@/assets/img/mouth-open.png");
  }
  12.66%, 20.33% {
    background-image: url("~@/assets/img/mouth-mid-open.png");
  }
  20.33%, 30% {
    background-image: url("~@/assets/img/mouth.png");
  }
  30%, 50.64% {
    background-image: url("~@/assets/img/mouth-mid-open.png");
  }
  50%, 70% {
    background-image: url("~@/assets/img/mouth-open.png");
  }
  70%, 80% {
    background-image: url("~@/assets/img/mouth.png");
  }
  80%, 90% {
    background-image: url("~@/assets/img/mouth-mid-open.png");
  }
  90%, 100% {
    background-image: url("~@/assets/img/mouth.png");
  }
}

.activate {
  .eyes {
    display: block;
    position: absolute;
    top: fluid(86px);
    left: fluid(165px);
    width: fluid(20px);
    height: fluid(40px);
    background-image: url("~@/assets/img/eyes-open.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
    animation: blink 4.5s step-start;
    background-size: contain;
  }
 .mouth {
    display: block;
    position: absolute;
    top: fluid(114px);
    left: fluid(162px);
    width: fluid(20px);
    height: fluid(30px);
    background-image: url("~@/assets/img/mouth.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
    animation: talk 7.5s step-start;
  }
}
</style>